/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const controllerTokens = {
  ContainerBackgroundColorBaseDefault: '#ffffff',
  ContainerBackgroundColorDisabledDefault: '#ebecec',
  ContainerBorderStyleBaseDefault: 'solid',
  ContainerBorderWidthBaseDefault: '1px',
  ContainerBorderWidthBaseKeyboardFocus: '1px',
  ContainerBorderRadiusBaseDefault: '4px',
  ContainerBorderColorBaseDefault: '#c4c4c4',
  ContainerBorderColorBaseHover: '#394040',
  ContainerBorderColorBaseKeyboardFocus: '#285da3',
  ContainerBorderColorInvalidDefault: '#c41936',
  ContainerBorderColorDisabledDefault: '#ebecec',
  ContainerShadowColorBaseKeyboardFocus: '#8babd6',
  ContainerShadowColorInvalidKeyboardFocus: '#e9778a',
  ContainerShadowWidthBaseKeyboardFocus: '4px',
  ContainerShadowWidthInvalidKeyboardFocus: '4px',
  ContainerFontFamilyBaseDefault: '"Inter var", "fallback for Inter", sans-serif',
  ContainerFontSizeBaseDefault: '14px',
  ContainerFontLeadingBaseDefault: '24px',
  ContainerFontWeightBaseDefault: '400',
  ContainerFontWeightAgreementDefault: '500',
  ContainerFontColorBaseDefault: '#1c2222',
  ContainerFontColorDisabledDefault: '#a7aaaa',
  ContainerFontColorPlaceholderDefault: '#cecfd1',
  IconColorBaseDefault: '#1c2222',
  IconColorBaseDisabled: '#a7aaaa',
  ErrorFontColorBaseDefault: '#c41936',
  ErrorFontSizeDefault: '12px',
  ErrorFontWeightDefault: '500',
  ErrorFontLeadingDefault: '20px',
  AffixBackgroundColorBaseDefault: '#f4f4f4',
  InputFontFeatureBase: '"ss01", "cv05", "cv10", "calt"',
} as const;
